import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'
import { push } from 'react-router-redux'
import config from 'config'
import { CONNECT_ERRORS } from '../component'
import { track } from 'utils/trackingUtils'
import { popUp, GoogleScopes, encodeQueryData } from '../../utils/oauthUtils'

import GoogleOauth from './component'

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})

const params = {
  redirect_uri: `${config.CUSTOMER_WEB_URL}/accept-integration/google-calendar`,
  client_id: config.GOOGLE_CLIENT_ID,
  response_type: 'code',
  access_type: 'offline',
  include_granted_scopes: true,
  scope: GoogleScopes.CALENDAR
}


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onConnectClick: props => () => {
      popUp({
        path: `https://accounts.google.com/o/oauth2/v2/auth?${encodeQueryData(params)}`,
        onMessage: (e) => {
          const success = e.data.status === 'success'
          if (success) {
            track('Onboarding Meetings Calendar Method Chosen', {
              context: 'sales-onboarding',
              method: 'google-calendar'
            })
            track('Calendar Connected', { context: 'onboarding' })
            window.drift && window.drift.api && window.drift.api.setUserAttributes({ first_calendar_connect: true })
            if (props.isCalendarSeat) {
              props.actions.push('/setup/calendaring/select')
            } else {
              props.actions.push('/setup/meetings/calendar')
            }
          } else {
            props.setConnectError(CONNECT_ERRORS.GMAIL)
          }
        },
      })
    },
  }),
)(GoogleOauth)



// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/GoogleOauth/index.js